import * as React from 'react';
import { Badge, BadgeProps } from '@fluentui/react-components';
import { PollState } from '../../services/DataService';
import { getStateMeta } from '../../lib/pollLabels';

export interface IStatusBadgeProps {
    state?: PollState | number | null;
    size?: BadgeProps['size'];
}

const StatusBadge: React.FC<IStatusBadgeProps> = ({ state, size = 'medium' }) => {
    const meta = getStateMeta(state);
    return (
        <Badge appearance="tint" color={meta.color} size={size} shape="rounded">
            {meta.label}
        </Badge>
    );
};

export default StatusBadge;
